const Request = require('./BaseRequest')
const CourseGraph = require('../graph/CourseGraph')

module.exports = class CourseRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new CourseGraph(this.apiDomain)
    }

    swrCourses()
    {
        let args = {is_active: 1}
        let { type, query } = this.graph.coursesQuery([
            'id', 'title', 'slug', 'type', 'description', 'feature_img', 'thumbnail'
        ], args)
        
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrCourse(slug)
    {
        let args = {slug: slug}
        let { type, query } = this.graph.courseQuery([
            'id', 'title', 'slug', 'type', 'description', 'feature_img', 'thumbnail'
        ], args)
        
        return this.graph.swrRequest(query, this.swrOptions, type)
    }


    async courses()
    {
        let args = {is_active: 1}
        let { type, query } = this.graph.coursesQuery([
            'id', 'title', 'slug', 'type', 'description', 'feature_img', 'thumbnail'
        ])

        let data = await this.graph.request(query, args, type)
        return data
    }

    async course(slug)
    {
        let args = {slug: slug}
        let { type, query } = this.graph.courseQuery([
            'id', 'title', 'slug', 'type','description', 'feature_img', 'thumbnail'
        ])

        let data = await this.graph.request(query, args, type)
        return data
    }


    async lessons(course_id)
    {
        let args = {course_id: course_id}
        let { type, query } = this.graph.lessonsQuery([
            'id', 'course_id', 'session', 'title', 'description', 'media', 'thumbnail'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async resources(course_id)
    {
        let args = {course_id: course_id}
        let { type, query } = this.graph.resourcesQuery([
            'id', 'course_id', 'title', 'description', 'media', 'thumbnail'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async discounts(course_id)
    {
        let args = {course_id: course_id}
        let { type, query } = this.graph.discountsQuery([
            'id', 'course_id', 'title', 'description', 'url', 'thumbnail'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrSession(session)
    {
        let args = {session: session}
        let { type, query } = this.graph.sessionQuery([
            'id', 'course_id', 'title'
        ], args)
        
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

}